import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, Image, StyleSheet } from 'react-native';
import { UserServiceClient } from 'fitbeat.api-clients';

import Icon from './Icon';
import Theme from '../theme';
import { defaultScale } from '../utils/scaling';
import { getApiConfig } from '../config';
import { MemoryImageCache } from '../services';
import { AuthTokenBuilder } from '../utils/authTokenBuilder';
import { GoogleAnalytics } from '../services/google-analytics';
import { AppStateFocusedEvents } from '../ui';

class Avatar extends PureComponent {
  userServiceClient;

  constructor(props) {
    super(props);
    const authTokenBuilder = this.props.isInfluencer
      ? null
      : new AuthTokenBuilder();
    this.userServiceClient = new UserServiceClient(
      getApiConfig(),
      fetch,
      console.log,
      authTokenBuilder,
      new GoogleAnalytics(),
    );
    this.state = {
      avatar: null,
    };
  }

  componentDidMount() {
    this.getAvatar();
  }

  componentDidUpdate(prevProps) {
    const { avatarId } = this.props;
    if (this.props.base64Avatar) {
      this.setState({
        avatar: this.props.base64Image,
      });
      MemoryImageCache.add(avatarId, this.props.base64Avatar);
      return;
    }
    if (prevProps.avatarId !== avatarId || this.props.forceUpdate) {
      this.getAvatar();
    }
  }

  getAvatar = async () => {
    const { avatarId, isInfluencer } = this.props;
    if (avatarId) {
      const avatar = await this.getCachedAvatarOrFetch(avatarId, isInfluencer);
      this.setState({ avatar });
    } else {
      this.setState({ avatar: null });
    }
  };

  getCachedAvatarOrFetch = async (avatarId, isInfluencer) => {
    const cachedAvatar = MemoryImageCache.get(avatarId);
    if (cachedAvatar) {
      return cachedAvatar;
    }

    const result = isInfluencer
      ? await this.userServiceClient.getInfluencerAvatar(avatarId)
      : await this.userServiceClient.getOtherUsersBase64Avatar(avatarId);

    if (result.base64Avatar) {
      MemoryImageCache.add(avatarId, result.base64Avatar);
      return result.base64Avatar;
    }
    return '';
  };

  render() {
    const { avatar } = this.state;
    const {
      size,
      iconColor = Theme.GREY,
      customStyle,
      showIcon,
      navigation,
    } = this.props;

    let avatarElement = showIcon ? (
      <View style={[styles.containerForNoIcon, customStyle || {
        height: size,
        width: size,
      }]}
      >
        <Icon
          size={size}
          color={iconColor}
          style={[styles.center, { lineHeight: size }]}
          name='ios-contact-outline'
        />
      </View>
    ) : (
      <View
        style={[styles.center, customStyle || {
          height: size,
          width: size,
        }]}
      />
    );

    if (avatar) {
      avatarElement = (
        <Image
          style={[styles.avatar, customStyle || { width: size, height: size }]}
          source={{ uri: `data:image/png;base64,${avatar}` }}
        />
      );
    }

    return (
      <>
        {avatarElement}
        <AppStateFocusedEvents
          navigation={navigation}
          enableBackgroundFocusEvent={false}
          onScreenFocus={this.getAvatar}
        />
      </>
    );
  }
}

Avatar.propTypes = {
  avatarId: PropTypes.string,
  iconColor: PropTypes.string,
  isInfluencer: PropTypes.boolean,
  showIcon: PropTypes.boolean,
  size: PropTypes.number,
};

Avatar.defaultProps = {
  showIcon: true,
  size: defaultScale(30),
};

const styles = StyleSheet.create({
  avatar: {
    borderRadius: defaultScale(2),
    borderWidth: 1,
    alignSelf: 'center',
    borderColor: Theme.GREY,
  },
  noBorder: {
    borderWidth: 0,
  },
  center: {
    alignSelf: 'center',
  },
  containerForNoIcon: {
    justifyContent: 'center',
    alignSelf: 'center',
  },
});

export default Avatar;
